export default "//file.bilionpass.com/japandx-web/0.0.1/static/days-icon.1e1dd093-1350a1.svg";